interface ModalOverlayProps {
  onClick: () => void;
}

export function ModalOverlay({ onClick }: ModalOverlayProps) {
  return (
    <div
      className="fixed inset-0 bg-black/50 z-40"
      onClick={onClick}
      aria-hidden="true"
    />
  );
}
